"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylesheetDriver = exports.NATIVE_STATES = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@stylable/core");
var stylable_forcestates_plugin_1 = require("@stylable/webpack-extensions/dist/stylable-forcestates-plugin");
var postcss = tslib_1.__importStar(require("postcss"));
var mutable_ast_1 = require("./mutable-ast");
var rule_order_utils_1 = require("./rule-order-utils");
// TODO: Get from Stylable (nativePseudoElements)
exports.NATIVE_STATES = ['hover', 'focus', 'disabled', 'active'];
var NATIVE_STATES_BY_ORDER = ['hover', 'active', 'focus', 'disabled'];
var hasOwnProperty = Object.prototype.hasOwnProperty;
var counter = 0;
var appendNamedToRule = function (rule, originalNamed, newNamed) {
    // Remove previous named if exists
    if (rule.nodes) {
        var named = rule.nodes.find(function (decl) { return decl.type === 'decl' && decl.prop === '-st-named'; });
        if (named) {
            rule.removeChild(named);
        }
    }
    // Add original named
    var resultNamed = originalNamed ? tslib_1.__assign({}, originalNamed) : {};
    // Add new named
    if (newNamed) {
        newNamed.forEach(function (name) {
            // Check if new name already exists (AS SOURCE), if not - add it
            if (!Object.keys(resultNamed).find(function (key) { return resultNamed[key] === name; })) {
                // Name not found - add name
                resultNamed[name] = name;
            }
        });
    }
    if (Object.keys(resultNamed).length > 0) {
        var namedValue = Object.keys(resultNamed)
            .map(function (key) {
            if (key !== resultNamed[key]) {
                return "".concat(resultNamed[key], " as ").concat(key);
            }
            return key;
        })
            .join(', ');
        var namedStatement = postcss.decl({
            prop: '-st-named',
            value: namedValue,
        });
        rule.append(namedStatement);
    }
    return resultNamed;
};
// TODO: move to language-service-tools?
var generateNewImport = function (defaultImport, path) {
    var rule = postcss.rule({ selector: ':import' });
    var fromStatement = postcss.decl({
        prop: '-st-from',
        value: "'".concat(path, "'"),
    });
    var defaultStatement = postcss.decl({
        prop: '-st-default',
        value: defaultImport,
    });
    rule.append(fromStatement);
    rule.append(defaultStatement);
    return rule;
};
var parseScope = function (scope) {
    var scopeMatch = scope.match(/@(\S+)\s*(.*)/);
    if (!scopeMatch) {
        return undefined;
    }
    return { name: scopeMatch[1], params: scopeMatch[2] };
};
var isStScope = function (scope) { return scope.startsWith('@st-scope'); };
var StylesheetDriver = /** @class */ (function () {
    function StylesheetDriver(getMeta, updateFromAST, getTransformer, scope, transformationPlugins, experiments) {
        if (experiments === void 0) { experiments = {}; }
        var _this = this;
        this.getMeta = getMeta;
        this.updateFromAST = updateFromAST;
        this.getTransformer = getTransformer;
        this.scope = scope;
        this.transformationPlugins = transformationPlugins;
        this.experiments = experiments;
        this.findRuleByState = function (selectors, newSelector) {
            var newSelectorNoState = newSelector;
            var prevRule;
            // find same element without state:
            if ((0, rule_order_utils_1.doesEndWithState)(newSelector)) {
                newSelectorNoState = newSelector.substring(0, newSelector.lastIndexOf(':'));
                var newSelectorState_1 = newSelector.substring(newSelector.lastIndexOf(':') + 1);
                var newSelectorParts = newSelectorNoState.split('::');
                var relevantClassName = newSelectorParts[newSelectorParts.length - 1];
                relevantClassName = relevantClassName[0] === '.' ? relevantClassName.substring(1) : relevantClassName;
                var stateList_1 = NATIVE_STATES_BY_ORDER.concat(_this.getStyleStates(relevantClassName));
                var sameElementIndex = selectors.findIndex(function (select) { return select === newSelectorNoState; });
                var amongstOtherStates_1;
                selectors.forEach(function (select, index) {
                    if (select !== newSelectorNoState &&
                        select.startsWith(newSelectorNoState) &&
                        stateList_1 &&
                        (0, rule_order_utils_1.doesEndWithState)(select)) {
                        var selectState_1 = select.substring(select.lastIndexOf(':') + 1);
                        if (stateList_1.findIndex(function (value) { return value === selectState_1; }) <
                            stateList_1.findIndex(function (value) { return value === newSelectorState_1; })) {
                            amongstOtherStates_1 = index;
                        }
                    }
                });
                if (amongstOtherStates_1 !== undefined) {
                    prevRule = amongstOtherStates_1;
                }
                else if (sameElementIndex !== -1) {
                    // didn't find any other states which should come before this state
                    prevRule = sameElementIndex;
                }
            }
            return prevRule;
        };
    }
    Object.defineProperty(StylesheetDriver.prototype, "path", {
        get: function () {
            return this.getMeta().source;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylesheetDriver.prototype, "AST", {
        get: function () {
            return this.getMeta().rawAst;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylesheetDriver.prototype, "processedAST", {
        get: function () {
            return this.getMeta().ast;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylesheetDriver.prototype, "outputAst", {
        get: function () {
            return this.getMeta().outputAst;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylesheetDriver.prototype, "namespace", {
        get: function () {
            return this.getMeta().namespace;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylesheetDriver.prototype, "source", {
        get: function () {
            return this.AST.toString();
        },
        enumerable: false,
        configurable: true
    });
    StylesheetDriver.prototype.getActiveScopes = function () {
        return new Set(this.scope ? [this.scope] : undefined);
    };
    StylesheetDriver.prototype.getExperiments = function () {
        return this.experiments;
    };
    StylesheetDriver.prototype.walkRules = function (callback, ast, scope, onlyScope) {
        var _this = this;
        if (ast === void 0) { ast = this.AST; }
        if (scope === void 0) { scope = this.scope; }
        if (onlyScope === void 0) { onlyScope = false; }
        var scopeAtRules = [];
        if (scope) {
            scopeAtRules = this.queryScopeRules(scope, ast);
        }
        return ast.walkRules(function (rule) {
            if ((ast === _this.processedAST || ast === _this.outputAst) && _this.isProcessedStScopeRule(rule)) {
                if (!scope) {
                    return;
                }
                var parsedScope = parseScope(scope);
                if (!parsedScope || !rule.selector.startsWith(parsedScope.params)) {
                    return;
                }
            }
            if ((onlyScope && rule.parent === ast) ||
                (rule.parent !== ast &&
                    (scopeAtRules.length <= 0 || !scopeAtRules.find(function (scopeRule) { return scopeRule === rule.parent; })))) {
                return;
            }
            return callback(rule);
        });
    };
    // TODO move import logic to import driver
    StylesheetDriver.prototype.getImportByPath = function (path) {
        var e_1, _a;
        var imports = this.getMeta().imports;
        try {
            for (var imports_1 = tslib_1.__values(imports), imports_1_1 = imports_1.next(); !imports_1_1.done; imports_1_1 = imports_1.next()) {
                var currentImport = imports_1_1.value;
                if (currentImport.from === path) {
                    var importData = Object.assign({
                        from: path,
                        default: currentImport.defaultExport,
                    }, Object.keys(currentImport.named).length > 0 ? { named: currentImport.named } : {});
                    return importData;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (imports_1_1 && !imports_1_1.done && (_a = imports_1.return)) _a.call(imports_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return null;
    };
    StylesheetDriver.prototype.upsertImport = function (_a) {
        var path = _a.path, named = _a.named, _b = _a.requestedDefaultImportName, requestedDefaultImportName = _b === void 0 ? 'Import' : _b;
        var importData = this.getImportByPath(path);
        if (importData && !named) {
            return importData;
        }
        var ast = this.AST;
        var defaultImport;
        var rule;
        if (importData) {
            // Get original rule if exists:
            defaultImport = importData.default;
            rule = this.queryImportRule(path);
            ast.removeChild(rule); // TODO maybe can remove
        }
        else {
            // new rule:
            // TODO try first requestedDefaultImportName or generate name from path and add counter if name is not available in context
            defaultImport = requestedDefaultImportName + counter++;
            rule = generateNewImport(defaultImport, path);
        }
        var newNamed = appendNamedToRule(rule, (importData && importData.named) || undefined, named);
        ast.prepend(rule);
        this.updateFromAST(rule);
        importData = {
            from: path,
            default: defaultImport,
            named: newNamed,
        };
        return importData;
    };
    StylesheetDriver.prototype.queryStyleRule = function (selector, scope, onlyScope) {
        if (scope === void 0) { scope = this.scope; }
        if (onlyScope === void 0) { onlyScope = false; }
        var result = [];
        this.walkRules(function (rule) {
            if (rule.selector === selector) {
                result.push(rule);
            }
        }, this.AST, scope, onlyScope);
        return result;
    };
    StylesheetDriver.prototype.queryStyleRuleWithScopeFilter = function (selector, useScope) {
        if (useScope === void 0) { useScope = true; }
        return this.queryStyleRule(selector, useScope ? this.scope : '', useScope ? !!this.scope : false);
    };
    StylesheetDriver.prototype.queryImportRule = function (path) {
        var result;
        this.walkRules(function (rule) {
            if (rule.selector !== ':import') {
                return;
            }
            if (rule.nodes &&
                rule.nodes.find(function (decl) {
                    return (decl.type === 'decl' &&
                        decl.prop === '-st-from' &&
                        decl.value.replace(/['"]+/g, '').replace(/^\./, '') === path);
                })) {
                result = rule;
            }
        });
        return result;
    };
    StylesheetDriver.prototype.upsertStyleRule = function (selector, placeInOrder, useScope) {
        if (placeInOrder === void 0) { placeInOrder = false; }
        if (useScope === void 0) { useScope = true; }
        var result = this.queryStyleRuleWithScopeFilter(selector, useScope);
        if (result.length !== 0) {
            return result;
        }
        var parent = !useScope || !this.scope ? this.AST : this.upsertScopeRule(this.scope);
        if (!parent) {
            return result;
        }
        var newRule = postcss.rule({ selector: selector });
        if (!placeInOrder) {
            parent.append(newRule);
        }
        else {
            var selectors = [];
            for (var index = 0; index < parent.nodes.length; index++) {
                var node = parent.nodes[index];
                if (node.type === 'rule') {
                    selectors.push({ selector: node.selector, index: index });
                }
            }
            var prevRule = this.findRuleIndex(selector, selectors);
            parent.insertAfter(prevRule, newRule);
        }
        result.push(newRule);
        return result;
    };
    StylesheetDriver.prototype.queryScopeRules = function (scope, ast) {
        if (ast === void 0) { ast = this.AST; }
        if (ast === this.AST || !isStScope(scope)) {
            var result_1 = [];
            ast.walkAtRules(function (rule) {
                if (scope === "@".concat(rule.name, " ").concat(rule.params)) {
                    result_1.push(rule);
                }
            });
            return result_1;
        }
        else {
            /**TODO: THIS BROKEN! */
            var result_2 = [];
            var parsedScope_1 = parseScope(scope);
            if (!parsedScope_1) {
                return result_2;
            }
            ast.walkRules(function (rule) {
                if (rule.selector.startsWith(parsedScope_1.params)) {
                    result_2.push(rule);
                }
            });
            return result_2;
        }
    };
    StylesheetDriver.prototype.upsertScopeRule = function (scope) {
        var result = this.queryScopeRules(scope);
        if (result.length > 0) {
            /** TODO: this needs to find the matching atRule */
            return result[result.length - 1];
        }
        var parsedScope = parseScope(scope);
        if (!parsedScope) {
            return undefined;
        }
        var name = parsedScope.name, params = parsedScope.params;
        var newScopeRule = postcss.atRule({ name: name, params: params, nodes: [] });
        this.AST.append(newScopeRule);
        return newScopeRule;
    };
    StylesheetDriver.prototype.removeRule = function (rule) {
        this.withAST(function (ast) { return ast.removeChild(rule); });
    };
    StylesheetDriver.prototype.addRule = function (rule) {
        this.withAST(function (ast) { return ast.append(rule); });
    };
    StylesheetDriver.prototype.getSymbol = function (name) {
        return this.getMeta().mappedSymbols[name];
    };
    StylesheetDriver.prototype.getSymbolType = function (name) {
        var symbol = this.getSymbol(name);
        return symbol ? symbol._kind : '';
    };
    StylesheetDriver.prototype.resolveSymbolType = function (symbol) {
        if (!symbol) {
            return '';
        }
        var transformer = this.getTransformer();
        if (!transformer) {
            return '';
        }
        if (symbol._kind === 'import') {
            var resolved = transformer.resolver.deepResolve(symbol);
            if (resolved && resolved.symbol) {
                return resolved._kind === 'js' ? 'js' : resolved.symbol._kind;
            }
        }
        return symbol._kind;
    };
    StylesheetDriver.prototype.upsertDeclarationToRule = function (selector, decl) {
        var result = this.queryStyleRule(selector, this.scope, !!this.scope);
        if (result.length > 0) {
            var rule = result[!this.scope ? 0 : result.length - 1];
            var foundProp = rule.nodes.find(function (declaration) { return declaration.prop === decl.prop; });
            if (decl.value) {
                if (this.transformationPlugins) {
                    decl.value = this.transformationPlugins.reduce(function (previousValue, currentTransformation) { return currentTransformation(previousValue); }, decl.value);
                }
                if (foundProp) {
                    foundProp.replaceWith(postcss.decl(decl));
                }
                else {
                    rule.append(postcss.decl(decl));
                }
                this.updateFromAST(rule);
            }
            else if (foundProp && decl.value === undefined) {
                foundProp.remove();
                this.updateFromAST(rule);
            }
        }
    };
    StylesheetDriver.prototype.upsertExtends = function (selector, componentType) {
        this.upsertDeclarationToRule(selector, {
            prop: '-st-extends',
            value: componentType,
        });
    };
    StylesheetDriver.prototype.extractDeclarations = function (fromRule, toRule, filter) {
        if (filter === void 0) { filter = function () { return true; }; }
        this.moveDeclarations(fromRule, toRule, filter);
        this.updateFromAST(fromRule); // ToDo: change writeFile to accept a list of modified nodes
        this.updateFromAST(toRule);
    };
    StylesheetDriver.prototype.extractToRule = function (fromRule, newRulename, filter, destRule) {
        var _this = this;
        if (filter === void 0) { filter = function () { return true; }; }
        if (destRule === void 0) { destRule = null; }
        this.withAST(function (ast) {
            var newRule = postcss.rule({ selector: newRulename });
            _this.moveDeclarations(fromRule, newRule, filter);
            ast.insertBefore(destRule || fromRule, newRule);
        });
    };
    StylesheetDriver.prototype.replaceRule = function (fromRule, destRule, filter) {
        var _this = this;
        if (filter === void 0) { filter = function () { return true; }; }
        this.withAST(function (ast) {
            var newRule = postcss.rule({ selector: destRule.selector });
            _this.moveDeclarations(fromRule, newRule, filter);
            ast.insertBefore(destRule, newRule);
            ast.removeChild(destRule);
        });
    };
    StylesheetDriver.prototype.getNodeById = function (id) {
        var foundNode = null;
        this.AST.walkRules(function (rule) {
            if (foundNode) {
                return;
            }
            if ((0, mutable_ast_1.getNodeId)(rule) === id) {
                foundNode = rule;
                return;
            }
            rule.walkDecls(function (decl) {
                if (foundNode) {
                    return;
                }
                if ((0, mutable_ast_1.getNodeId)(decl) === id) {
                    foundNode = decl;
                    return;
                }
            });
        });
        return foundNode;
    };
    // TODO: Move to stylable
    StylesheetDriver.prototype.getVarSymbols = function () {
        var _this = this;
        var meta = this.getMeta();
        var transformer = this.getTransformer();
        if (!transformer) {
            return {};
        }
        var importedVars = meta.imports.reduce(function (importVars, importObj) {
            Object.keys(importObj.named).forEach(function (importName) {
                var importSymbol = _this.getSymbol(importName);
                var varResolvedSymbol = importSymbol;
                if (importSymbol._kind === 'import') {
                    var resolved = transformer.resolver.deepResolve(importSymbol);
                    if (resolved && resolved.symbol) {
                        varResolvedSymbol = resolved.symbol;
                    }
                }
                if (varResolvedSymbol._kind === 'var') {
                    importVars[importName] = varResolvedSymbol;
                }
            });
            return importVars;
        }, {});
        var localVars = meta.vars.reduce(function (metaVars, varObj) {
            metaVars[varObj.name] = varObj;
            return metaVars;
        }, {});
        return tslib_1.__assign(tslib_1.__assign({}, importedVars), localVars);
    };
    Object.defineProperty(StylesheetDriver.prototype, "vars", {
        get: function () {
            return Object.keys(this.getVarSymbols());
        },
        enumerable: false,
        configurable: true
    });
    StylesheetDriver.prototype.getNewPalleteVars = function () {
        var _this = this;
        var varNames = this.getVarNames();
        return varNames
            .filter(function (varName) { return /color_\d{2}/.test(varName); })
            .map(function (name) { return ({ name: name, value: _this.getVarValue(name) }); });
    };
    StylesheetDriver.prototype.getGroupVars = function (pattern, dimensions) {
        var _this = this;
        var varNames = this.getVarNames();
        var output = [];
        varNames.forEach(function (name) {
            var nameMatch = name.match(pattern);
            if (!nameMatch || nameMatch[1] === undefined || (dimensions === 2 && nameMatch[2] === undefined)) {
                return;
            }
            var rowIndex = parseInt(nameMatch[1], 10);
            var colIndex = dimensions === 2 ? parseInt(nameMatch[2], 10) : -1;
            if (dimensions === 2 && output[rowIndex] === undefined) {
                output[rowIndex] = [];
            }
            var value = _this.getVarValue(name);
            if (dimensions === 2) {
                output[rowIndex][colIndex] = { name: name, value: value };
            }
            else {
                output[rowIndex] = { name: name, value: value };
            }
        });
        output = output.filter(function (palette) { return !!palette; });
        if (dimensions === 2) {
            output = output.map(function (palette) { return palette.filter(function (varObj) { return !!varObj; }); });
        }
        return output;
    };
    StylesheetDriver.prototype.getVarValue = function (name) {
        return this.evalDeclarationValue("value(".concat(name, ")"));
    };
    StylesheetDriver.prototype.setVar = function (name, value) {
        var varsRules = this.upsertStyleRule(':vars', false, false);
        var found = false;
        var updatedRule = varsRules[0];
        varsRules.forEach(function (rule) {
            if (!found) {
                rule.walkDecls(function (decl) {
                    if (!found) {
                        if (decl.prop === name) {
                            found = true;
                            updatedRule = rule;
                            decl.value = value;
                        }
                    }
                });
            }
        });
        if (!found) {
            updatedRule.append(postcss.decl({ prop: name, value: value }));
        }
        this.updateFromAST(updatedRule);
    };
    StylesheetDriver.prototype.deleteVar = function (name) {
        var varsRules = this.queryStyleRule(':vars', '');
        if (varsRules.length === 0) {
            return;
        }
        var found = false;
        var updatedRule = varsRules[0];
        varsRules.forEach(function (rule) {
            if (!found) {
                rule.walkDecls(function (decl) {
                    if (!found) {
                        if (decl.prop === name) {
                            found = true;
                            updatedRule = rule;
                            rule.removeChild(decl);
                        }
                    }
                });
            }
        });
        if (found) {
            this.updateFromAST(updatedRule);
        }
    };
    StylesheetDriver.prototype.evalDeclarationValue = function (value, overrides) {
        if (!value) {
            return '';
        }
        var transformer = this.getTransformer();
        return transformer
            ? (0, core_1.evalDeclarationValue)(transformer.resolver, value, this.getMeta(), postcss.decl({ prop: '', value: value }), overrides)
            : value;
    };
    StylesheetDriver.prototype.evalDeclarationProp = function (prop) {
        var transformer = this.getTransformer();
        if ((0, core_1.isCSSVarProp)(prop) && transformer) {
            var scopedVar = (0, core_1.scopeCSSVar)(transformer.resolver, this.getMeta(), prop);
            return scopedVar ? scopedVar : prop;
        }
        return prop;
    };
    StylesheetDriver.prototype.collectSelectorUsedProps = function (selector) {
        var retVal = [];
        this.walkRules(function (rule) {
            var arraysEqual = (0, core_1.matchSelectorTarget)(selector, rule.selector);
            if (arraysEqual && rule.nodes) {
                // match:
                // TODO: Refactor to walkDecls
                retVal = retVal.concat(rule.nodes.filter(function (node) { return node.type === 'decl'; }).map(function (decl) { return decl.prop; }));
            }
        });
        return retVal;
    };
    StylesheetDriver.prototype.getCSSMixinOverrides = function (name) {
        var overrides = [];
        var mixinSubset = (0, core_1.createSubsetAst)(this.AST, ".".concat(name));
        mixinSubset.walkDecls(function (decl) {
            var valueRegex = /value\((\S[^()]+)\)/g;
            var regexResult;
            while ((regexResult = valueRegex.exec(decl.value)) !== null) {
                var result = regexResult[1];
                !~overrides.indexOf(result) && overrides.push(result);
            }
        });
        return overrides;
    };
    StylesheetDriver.prototype.getStyleStates = function (className) {
        var styles = [];
        var symbol = this.getSymbol(className);
        var transformer = this.getTransformer();
        if (transformer) {
            while (symbol) {
                if (symbol['-st-states']) {
                    styles = Object.keys(symbol['-st-states']).concat(styles);
                }
                var resolved = transformer.resolver.deepResolve(symbol);
                symbol = resolved && resolved.symbol;
            }
        }
        return styles;
    };
    StylesheetDriver.prototype.getVariantStyleRules = function (selector) {
        var result = [];
        this.walkRules(function (rule) {
            if (rule.selector.match(new RegExp("^".concat(selector, "$|^").concat(selector, "[:].*$")))) {
                result.push(rule);
            }
        });
        return result;
    };
    StylesheetDriver.prototype.getTargetRule = function (selector, applyForceStates) {
        if (applyForceStates === void 0) { applyForceStates = false; }
        var transformer = this.getTransformer();
        var targetSelector = transformer.scopeSelector(this.getMeta(), selector).selector;
        var mockAst = postcss.root({ nodes: [postcss.rule({ selector: targetSelector })] });
        if (applyForceStates) {
            (0, stylable_forcestates_plugin_1.applyStylableForceStateSelectors)(mockAst);
        }
        return mockAst.nodes[0];
    };
    StylesheetDriver.prototype.getTargetSelector = function (selector, applyForceStates) {
        if (applyForceStates === void 0) { applyForceStates = false; }
        return this.getTargetRule(selector, applyForceStates).selector;
    };
    StylesheetDriver.prototype.getVariantStates = function (variant) {
        var states = [];
        var meta = this.getMeta();
        var transformer = this.getTransformer();
        if (!transformer) {
            return [];
        }
        var elements = transformer.resolveSelectorElements(meta, variant)[0];
        var element = elements[elements.length - 1];
        element.resolved.forEach(function (resolve) {
            if (!hasOwnProperty.call(resolve.symbol, '-st-states')) {
                return;
            }
            var newStates = Object.keys(resolve.symbol['-st-states']).filter(function (state) { return !~states.indexOf(state); });
            states = states.concat(newStates);
        });
        return states.concat(exports.NATIVE_STATES);
    };
    StylesheetDriver.prototype.getVariantUsedStates = function (variant) {
        var _this = this;
        var meta = this.getMeta();
        var transformer = this.getTransformer();
        if (!transformer) {
            return [];
        }
        var possibleStates = this.getVariantStates(variant);
        var usedStates = new Set();
        if (meta.outputAst) {
            possibleStates.forEach(function (state) {
                var selector = transformer.scopeSelector(meta, "".concat(variant, ":").concat(state)).selector;
                _this.walkRules(function (rule) {
                    if (rule.selector.includes(selector) &&
                        rule.nodes &&
                        rule.nodes.filter(function (node) { return node.type !== 'comment'; }).length > 0) {
                        usedStates.add(state);
                    }
                }, meta.outputAst);
            });
        }
        else {
            throw new Error('stylesheet meta not yet initialized.');
        }
        return Array.from(usedStates);
    };
    StylesheetDriver.prototype.withAST = function (cb) {
        var ast = this.AST;
        cb(ast);
        this.updateFromAST(ast);
    };
    StylesheetDriver.prototype.getVarNames = function () {
        var varNames = [];
        var varRules = this.queryStyleRule(':vars', '');
        varRules.forEach(function (rule) {
            rule.walkDecls(function (decl) {
                varNames.push(decl.prop);
            });
        });
        return varNames;
    };
    StylesheetDriver.prototype.findRuleIndex = function (newSelector, selectors) {
        var prevRules = [];
        var prevRule;
        var selectorStrings = selectors.map(function (select) { return select.selector; });
        prevRule = this.findRuleByState(selectorStrings, newSelector);
        prevRule !== undefined && prevRules.push(prevRule);
        prevRule = (0, rule_order_utils_1.findRuleBySameDeepness)(selectorStrings, newSelector);
        prevRule !== undefined && prevRules.push(prevRule);
        prevRule = (0, rule_order_utils_1.findRuleByClosestAncestor)(selectorStrings, newSelector);
        prevRule !== undefined && prevRules.push(prevRule);
        prevRule = (0, rule_order_utils_1.findRuleByDeepness)(selectorStrings, newSelector);
        prevRule !== undefined && prevRules.push(prevRule);
        var indexInRefList = prevRules.length > 0 ? prevRules[0] : selectors.length - 1;
        return indexInRefList !== -1 ? selectors[indexInRefList].index : -1; // if got index -1, return index-1 so that the rule is added first (index 0)
    };
    StylesheetDriver.prototype.moveDeclarations = function (fromRule, toRule, filter) {
        if (filter === void 0) { filter = function () { return true; }; }
        /* TODO: Get computed declaration out of mixin - whether it's just a class, or js mixin */
        var newDeclarations = [];
        fromRule.walkDecls(function (decl) {
            if (!filter(decl.prop)) {
                return;
            }
            fromRule.removeChild(decl);
            newDeclarations.push(postcss.decl(decl));
        });
        newDeclarations.forEach(function (decl) { return toRule.append(decl); });
    };
    StylesheetDriver.prototype.isProcessedStScopeRule = function (rule) {
        return (!!~rule.selector.indexOf(' ') &&
            rule.selectors.length === 1 &&
            !rule.selector.startsWith(".".concat(this.namespace)));
    };
    return StylesheetDriver;
}());
exports.StylesheetDriver = StylesheetDriver;
//# sourceMappingURL=stylable-stylesheet.js.map